import * as React from 'react';

export const ModalBody = (props: any) => <div className="modal-body" {...props}>{props.children}</div>;



// WEBPACK FOOTER //
// ./src/components/Modal/ModalBody.tsx